import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { IoAlertCircleOutline, IoCheckmarkOutline, IoCopyOutline } from 'react-icons/io5'

const codeCopyButtonSelector = '[data-code-copy]'
const codeCopiedLabel = 'コピーしました'
const codeCopyFailedLabel = 'コピー失敗'
const copyFeedbackDuration = 2000
const codeCopyIconMarkup = renderToStaticMarkup(<IoCopyOutline aria-hidden="true" focusable="false" />)
const codeCopiedIconMarkup = renderToStaticMarkup(<IoCheckmarkOutline aria-hidden="true" focusable="false" />)
const codeCopyFailedIconMarkup = renderToStaticMarkup(<IoAlertCircleOutline aria-hidden="true" focusable="false" />)
const codeCopiedMarkup = `<span class="gatsby-code-copy-label">copied</span>${codeCopiedIconMarkup}`
const codeCopyFeedbackTimers = new WeakMap()

/** テキストをクリップボードへコピーし，利用できない環境では旧来のAPIへフォールバックする． */
const copyText = async (value) => {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(value)
      return true
    }
    catch (_) {
      // Clipboard APIを利用できない場合は下のフォールバックを試す．
    }
  }

  const textarea = document.createElement('textarea')
  textarea.value = value
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.append(textarea)
  try {
    textarea.select()
    return document.execCommand('copy')
  }
  catch (_) {
    return false
  }
  finally {
    textarea.remove()
  }
}

/** コピー結果をボタンへアイコンで一時表示する． */
const showCopyFeedback = (button, label, iconMarkup) => {
  window.clearTimeout(codeCopyFeedbackTimers.get(button))
  button.innerHTML = iconMarkup
  button.setAttribute('aria-label', label)
  button.disabled = true

  const timer = window.setTimeout(() => {
    button.innerHTML = codeCopyIconMarkup
    button.setAttribute('aria-label', 'コードをコピー')
    button.disabled = false
    codeCopyFeedbackTimers.delete(button)
  }, copyFeedbackDuration)
  codeCopyFeedbackTimers.set(button, timer)
}

const isTouchDevice = () => window.matchMedia('(hover: none), (pointer: coarse)').matches

const hideCodeCopyButtons = (except) => {
  document.querySelectorAll('[data-code-copy-visible]').forEach(highlight => {
    if (highlight !== except) highlight.removeAttribute('data-code-copy-visible')
  })
}

const handleCodeCopy = async (event) => {
  if (!(event.target instanceof Element)) return

  const button = event.target.closest(codeCopyButtonSelector)
  if (!button) {
    if (!isTouchDevice()) return

    const highlight = event.target.closest('.gatsby-highlight')
    hideCodeCopyButtons(highlight)
    highlight?.setAttribute('data-code-copy-visible', '')
    return
  }

  if (button.disabled) return

  const code = button.closest('.gatsby-highlight')?.querySelector('code')
  if (!code) {
    showCopyFeedback(button, codeCopyFailedLabel, codeCopyFailedIconMarkup)
    return
  }

  button.disabled = true
  const copied = await copyText(code.textContent)
  showCopyFeedback(
    button,
    copied ? codeCopiedLabel : codeCopyFailedLabel,
    copied ? codeCopiedMarkup : codeCopyFailedIconMarkup,
  )
}

export const initializeCodeCopy = () => {
  document.addEventListener('click', handleCodeCopy)
}
